import * as React from 'react'
import {
  Button,
  HeaderSection,
  Icon,
  IconType,
  Popover,
  Text,
  Heading
} from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { FC } from 'react'
import { ProTag } from 'components/ProTag'

type Props = {
  handleToggleModal: () => void
  allowCreateEditTemplates: boolean
}

const StyledHeading = styled(Heading)`
  font-size: 16px;
  font-weight: 500;
`

const StyledLink = styled(Heading)`
  font-size: 16px;
  font-weight: 500;
  margin-left: 5px;
`

const StyledLogoIcon = styled(Icon)`
  width: 26px;
  height: 26px;
`

const StyledLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 257px;
`

const StyledAnchor = styled.a`
  color: black;
  text-decoration: underline;
`

const StyledFlexContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SkillNeedTemplateHeaderSection: FC<Props> = ({
  handleToggleModal,
  allowCreateEditTemplates
}) => {
  const { t } = useTranslation()

  const renderButton = (
    <div>
      <Button
        disabled={!allowCreateEditTemplates}
        icon={<Icon name="PlusOutlined" />}
        variant="primary"
        onClick={handleToggleModal}
      >
        {t(`skillsAndNeeds.addNewSkill`)}
      </Button>
    </div>
  )

  return (
    <HeaderSection
      title={
        <StyledFlexContainer>
          {t('skillsAndNeeds.templateTitle')}
          <ProTag />
        </StyledFlexContainer>
      }
      iconColor="#EFEEFF"
      iconContent={<StyledLogoIcon customIcon={IconType.LogoPurple} />}
      rightChildren={
        !allowCreateEditTemplates ? (
          <Popover
            placement="bottomRight"
            content={
              <StyledLinkWrapper>
                <Text level={5}>{t('skillsAndNeeds.tableReadOnly')}</Text>
                <div>
                  <StyledHeading level={5}>
                    {t('skillsAndNeeds.tableReadOnlyDescription')}
                  </StyledHeading>
                  <StyledLink level={5}>
                    <StyledAnchor
                      href="https://support.logmycare.co.uk/en/articles/6987442-how-to-set-up-skills-for-your-service"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('skillsAndNeeds.tableReadOnlyLink')}
                    </StyledAnchor>
                  </StyledLink>
                </div>
              </StyledLinkWrapper>
            }
          >
            {renderButton}
          </Popover>
        ) : (
          renderButton
        )
      }
    />
  )
}

export default SkillNeedTemplateHeaderSection
